import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewPlatform } = appStoreLenses

export default viewPlatform
